import React, { useEffect, useState } from "react";

// route
import { useNavigate, useParams } from "react-router";

// api
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";

// component
import Header from "../common/header/Header";
import LeftConversationList from "./left-conversation-list";
import ChatBody from "./chat-body";

// icon
import NoConversation from "../../assets/images/no-conversation-vector.svg";

// store
import { useDispatch, useSelector } from "react-redux";
import { setCallData } from "../../reducer/slices/twilio-calls/call-slice";
import AllowedAccess from "../../guards/AllowedAccess";

const ConversationList = () => {
  const { id } = useParams();
  let navigate = useNavigate();
  const [call, setCall] = useState(false);
  const [allConList, getAllConList] = useState([]);
  const [allTrial, getAllTrial] = useState([]);
  const [allTrialUnread, getAllTrialUnread] = useState([]);
  const [selectedChatId, setSelectedChatId] = useState(id);
  const [getConversation, setGetConversation] = useState([]);
  const [currentChat, setCurrentChat] = useState({});
  const [search, setSearch] = useState("");
  const [showClose, setShowClose] = useState(false);
  const [mainChatList, setChatPatientList] = useState([]);
  const [unreadState, setUnreadState] = useState([]);
  const [noRecruiter, setNoRecruiter] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [trialInfo, setTrialInfo] = useState(null);
  const [toasts, setToasts] = useState([]);
  const user = useSelector((state) => state.user);
  const POLLING_INTERVAL = 5000;
  const dispatch = useDispatch();
  const fetchConversationData = async () => {
    try {
      const response = await axios
        .get(ENDPOINTS.CONVERSATION.GET_ALL_CONVERSATION, {
          headers: {
            "Content-Type": "application/json-patch+json",
            Accept: "text/plain",
          },
        })
        .then((res) => {
          if (res && res.data && res.data.data && res.data.data.length === 0) {
            setNoRecruiter(true);
          }
          getAllConList(res.data.data);
          const allTrialName = res.data.data.map((tn) => ({
            patientName: tn.patientName,
            msgContent: tn.msgContent,
            patientTrialJuncID: tn.patientTrialJuncID,
            lastOutreach: tn.lastOutreach,
            isUnread: tn.isUnread,
          }));
          getAllTrial([...allTrialName]);
          setChatPatientList([...allTrialName]);

          const initialiseUnread = res.data.data.find(
            (item) => item.isUnread === true
          );
          const unreadData = res.data.data
            .filter((tn) => tn.isUnread === true) // Filter items where isUnread is true
            .map((tn) => ({
              selectedChatId: tn.patientTrialJuncID,
              isUnread: tn.isUnread,
            }));

          // Update unreadState only if the new data is different
          if (JSON.stringify(unreadState) !== JSON.stringify(unreadData)) {
            setUnreadState(unreadData);
          }
        });
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.status &&
        error.response.status === 400
      ) {
        setNoRecruiter(true);
      }

      if (
        error &&
        error.response &&
        error.response.status &&
        error.response.status === 500
      ) {
        setNoRecruiter(true);
      }
    }
  };

  // Function to update unreadState from child
  const updateUnreadState = (selectedChatId, isUnread) => {
    setUnreadState((prevState) => {
      const updatedState = [...prevState];
      const messageIndex = updatedState.findIndex(
        (msg) => msg.selectedChatId === selectedChatId
      );

      if (isUnread && messageIndex === -1) {
        // Add the message if marking as unread
        updatedState.push({ selectedChatId, isUnread });
      } else if (!isUnread && messageIndex !== -1) {
        // Remove the message if marking as read
        updatedState.splice(messageIndex, 1);
      }

      return updatedState;
    });

    // Update `allTrial` to reflect the updated `isUnread` status
    getAllTrial((prevAllTrial) =>
      prevAllTrial.map((msg) =>
        msg.patientTrialJuncID === selectedChatId ? { ...msg, isUnread } : msg
      )
    );
  };

  useEffect(() => {
    fetchConversationData();
  }, []);

  //Search from header

  const onSearchClick = () => {
    if (!search) {
      return;
    }

    const lowerCaseSearchTerm = search.toLowerCase();

    const searchedValue = mainChatList.filter((item) => {
      return item.patientName.toLowerCase().includes(lowerCaseSearchTerm);
    });

    getAllTrial(searchedValue);
    setShowClose(true);
  };

  const onCloseClick = () => {
    getAllTrial([...mainChatList]);
    setSearch("");
    setShowClose(false);
  };

  // Search as you type

  const [query, setQuery] = useState(""); // Search query
  const onHandleSearch = (value) => {
    setQuery(value);

    // Filter the list based on the search query
    if (value) {
      const filteredData = mainChatList.filter((item) =>
        item.patientName.toLowerCase().includes(value.toLowerCase())
      );
      getAllTrial(filteredData);
    } else {
      getAllTrial(mainChatList); // Reset to the original list if input is empty
    }
  };

  // Clear the search input and reset the list
  const clearSearch = () => {
    setQuery(""); // Clear the search query
    getAllTrial(mainChatList); // Reset the list to the original
  };

  const addToast = (message, type) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000);
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  // Fetch the chat details when selectedChatId changes

  const getParticularChat = async () => {
    await axios
      .get(
        `${ENDPOINTS.CONVERSATION.GET_CONVERSATION_BY_TRIAL_ID}?patientTrialJuncId=${selectedChatId}`
      )
      .then((res) => {
        setTrialInfo({
          patientName: res.data.data.patientName,
          phoneNumber: res.data.data.phoneNumber,
          status: res.data.data.status,
          trialID: res.data.data.trialID,
          patientID: res.data.data.patientID,
          patientTrialJuncID: res.data.data.patientTrialJuncID,
          trialName: res.data.data.trialName,
          isChatByBot: res.data.data.isChatByBot,
          docuSignStatus: res.data.data.docuSignStatus,
        });
        setGetConversation(res.data.data.patientConversationNodes);
      });

    await axios
      .get(
        `${ENDPOINTS.CONVERSATION.GET_UPDATED_CONVERSATION}?patientTrialJuncId=${selectedChatId}&read=true`
      )
      .then(() => {
        updateUnreadState(selectedChatId, false);
      });
    const selectedChatData = allConList.find(
      (chat) => chat.patientTrialJuncID === selectedChatId
    );
    setCurrentChat(selectedChatData);
    // const currentTrialName = {
    //   trialName: selectedChatData.trialName
    // }
    //setSelectedTrialName(currentTrialName)
  };

  useEffect(() => {
    setSelectedChatId(id);
  }, [id]);

  useEffect(() => {
    if (selectedChatId) {
      getParticularChat();
      const interval = setInterval(() => {
        getParticularChat();
      }, POLLING_INTERVAL); // Poll every 5 seconds

      return () => clearInterval(interval);
    }
  }, [selectedChatId]);

  useEffect(() => {
    if (
      chatMessages.length === 0 ||
      currentChat.msgContent !== chatMessages.at(-1).msgContent ||
      call
    ) {
      fetchConversationData();
    }
    setCall(false);
  }, [chatMessages]);

  useEffect(() => {
    if (selectedChatId) navigate(`/conversation-list/${selectedChatId}`);
  }, [selectedChatId]);

  const handleCall = async (phoneNumber) => {
    if (!phoneNumber) {
      return;
    }

    dispatch(
      setCallData({
        params: {
          To: phoneNumber,
          PatientID: trialInfo.patientID,
          PatientTrialJuncID: trialInfo.patientTrialJuncID,
          UserID: user.userProfile.userID,
        },
        trialInfo,
        call: true,
        route: `/conversation-list/${trialInfo.patientTrialJuncID}`,
      })
    );
  };

  return (
    <>
      <Header
        headertitle="Conversations"
        showClose={showClose}
        isSearch={true}
        search={search}
        setSearch={setSearch}
        onSearchClick={onSearchClick}
        onCloseClick={onCloseClick}
      />
      {noRecruiter === true ? (
        <div className="h-[calc(100vh-80px)] w-full flex flex-col items-center justify-center no-conversation actual-img-ratio">
          <img src={NoConversation} alt="" />
          <p className="mt-1 text-sm font-medium">No Conversations yet</p>
        </div>
      ) : (
        <div className="flex flex-row justify-content bg-white h-[calc(100vh-80px)] hover:bg-[#6D6BE61A]">
          <LeftConversationList
            onSelectChat={setSelectedChatId}
            selectedChatId={selectedChatId}
            allTrialUnread={allTrialUnread}
            onSearch={onHandleSearch}
            query={query}
            onClear={clearSearch}
            unreadState={unreadState}
            allTrial={allTrial}
            updateUnreadState={updateUnreadState}
            chatMessages={chatMessages}
            fetchConversationData={fetchConversationData}
          />

          <ChatBody
            handleCall={handleCall}
            trialInfo={trialInfo}
            id={selectedChatId}
            conversation={getConversation}
            onMessageSend={() => {
              fetchConversationData();
            }}
          />
        </div>
      )}
    </>
  );
};

export default ConversationList;
